import { Typography } from 'antd';

import ResetPassword from 'components/UserProfile/ResetPassword';

import styles from './ResetPassword.module.css';

const { Title } = Typography;

const ResetPasswordPage = () => {

  return (
    <div className={styles["user-profile-page"]}>
      <div className={styles["header-title"]}>
        <Title level={4} className="ml-3">Reset Password</Title>
      </div>
      <div>
        <ResetPassword
        />
      </div>
    </div>
  )
};

export default ResetPasswordPage;